import { render, staticRenderFns } from "./HeaderPopup.vue?vue&type=template&id=481fe943&"
import script from "./HeaderPopup.vue?vue&type=script&lang=js&"
export * from "./HeaderPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports